import { Card, CardHeader, CardContent, Stack, TextField, CardActions, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { departmentSchema } from '../schemas/departmentSchemas';
import { createDepartment, resetDepartmentState } from '../store/departmentActions';

DepartmentForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function DepartmentForm({ open, onClose }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.departmentReducer);

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess, onClose]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm } = useFormik({
    initialValues: { name: '', code: '' },
    validationSchema: departmentSchema,
    onSubmit: (vals) => {
      dispatch(createDepartment({ name: vals.name, code: vals.code || null }));
    },
  });

  const handleClose = () => {
    resetForm();
    dispatch(resetDepartmentState());
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '500px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardHeader title="Add Department" />
          <CardContent>
            <Stack spacing={3}>
              <TextField
                fullWidth
                name="name"
                label="Department Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />
              <TextField
                fullWidth
                name="code"
                label="Department Code (optional)"
                value={values.code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code && errors.code}
              />
            </Stack>
          </CardContent>
          <CardActions sx={{ p: 3, pt: 0 }}>
            <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'flex-end' }}>
              <LoadingButton variant="outlined" onClick={handleClose} disabled={isLoading}>
                Cancel
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" loading={isLoading} disabled={isSubmitting}>
                Create Department
              </LoadingButton>
            </Stack>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
